import styled from "styled-components";

export const PricingSection = styled("section")`
  position: relative;
  padding: 10rem 0 8rem;
  background: #f8f9fa;

  @media only screen and (max-width: 1024px) {
    padding: 4rem 0 4rem;
  }
`;

export const PricingWrapper = styled("div")`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

export const PricingCard = styled("div")<{ popular?: boolean }>`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  border: ${({ popular }) => popular ? "2px solid #18216d" : "1px solid #e8e8e8"};
  transform: ${({ popular }) => popular ? "scale(1.05)" : "scale(1)"};
  transition: all 0.3s ease;

  &:hover {
    transform: ${({ popular }) => popular ? "scale(1.05)" : "scale(1.02)"};
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  }
`;

export const PopularBadge = styled("div")`
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #18216d;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const PricingHeader = styled("div")`
  margin-bottom: 2rem;
`;

export const PricingTitle = styled("h3")`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #18216d;
`;

export const PricingPrice = styled("span")`
  font-size: 3rem;
  font-weight: bold;
  color: #18216d;
`;

export const PricingPeriod = styled("span")`
  font-size: 1rem;
  color: #666;
`;

export const FeatureList = styled("ul")`
  list-style: none;
  padding: 0;
  margin: 2rem 0;
`;

export const FeatureItem = styled("li")`
  padding: 0.5rem 0;
  color: #666;
  position: relative;

  &:before {
    content: "✓";
    color: #18216d;
    font-weight: bold;
    margin-right: 0.5rem;
  }
`;